import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  language: "en",
  userData: null,
  token: null,
  loading: false,
  error: null,
  isAdmin: false,
  apiCall: null,
  leaveapiCall: null,
  recurringapiCall: null,
  sideMenu: [],
  isApplicant: false,
  deleteapiCall: null,
  earnedapiCall: null,
  orgExpiringCall: null,
  selectedSub: {
    subLabel: null,
    titleLabel: null,
  },
  selectedTitle: null,
  orgLogo: null,
  applicantLoginData: null,
  employeeAllLeaveData: null,
  isAuthenticated: false,
  authChecked: false,
};

export const userDetailSlice = createSlice({
  name: "userDetail",
  initialState,
  reducers: {
    userLogin: (state, action) => {
      state.token = action.payload.Token;
      state.message = action.payload.message;
      state.userData = action.payload.userData;
      state.isAuthenticated = true;
      state.authChecked = true;
      localStorage.setItem("token", action.payload.Token);
      localStorage.setItem("orgId", action.payload.userData.orgId);
      localStorage.removeItem("email");
    },

    logOut: (state) => {
      state.token = null;
      state.userData = null;
      state.isAdmin = null;
      state.apiCall = null;
      state.isAuthenticated = false;
      state.authChecked = true;
      state.leaveapiCall = null;
      state.recurringapiCall = null;
      state.deleteapiCall = null;
      state.earnedapiCall = null;
      state.employeeAllLeaveData = null;
      state.message = null;
      state.sideMenu = [];
      state.orgExpiringCall = null;
      state.orgLogo = null;
      localStorage.removeItem("token");
      localStorage.removeItem("orgId");
      localStorage.removeItem("email");
      localStorage.removeItem("jobId");
      sessionStorage.removeItem("selectedOrg");
    },
    fetchUserData: (state, action) => {
      state.userData = action.payload || {};
    },

    setIsAdmin: (state, action) => {
      state.isAdmin = action.payload;
    },
    setSideMenu: (state, action) => {
      state.sideMenu = action.payload;
    },
    setEmployeeAllLeaveData: (state, action) => {
      state.employeeAllLeaveData = action.payload;
    },
    setAuthChecked: (state, action) => {
      state.authChecked = action.payload;
    },
    setAuthenticated: (state, action) => {
      state.isAuthenticated = action.payload;
    },

    setApiCall: (state, action) => {
      state.apiCall = action.payload;
    },
    setLeaveApiCall: (state, action) => {
      state.leaveapiCall = action.payload;
    },
    setEarnedApiCall: (state, action) => {
      state.earnedapiCall = action.payload;
    },
    setPermanentDeleteApiCall: (state, action) => {
      state.deleteapiCall = action.payload;
    },
    setRecurringLeaveApiCall: (state, action) => {
      state.recurringapiCall = action.payload;
    },
    setOrgExpiringCall: (state, action) => {
      state.orgExpiringCall = action.payload;
    },
    setSelectedSub: (state, action) => {
      state.selectedSub.subLabel = action.payload.subLabel;
      state.selectedSub.titleLabel = action.payload.titleLabel;
    },
    setSelectedTitle: (state, action) => {
      state.selectedTitle = action.payload;
      if (state.selectedSub.titleLabel !== action.payload) {
        state.selectedSub.titleLabel = action.payload;
        state.selectedSub.subLabel = null;
      }
    },
    resetSelected: (state, action) => {
      state.selectedSub.subLabel = null;
      state.selectedSub.titleLabel = null;
      state.selectedTitle = "Home";
    },
    setOrgLogo: (state, action) => {
      state.orgLogo = action.payload;
    },
    fetchApplicantLoginData: (state, action) => {
      state.applicantLoginData = action.payload || {};
    },
  },
  extraReducers: (builder) => {},
});

export const {
  userLogin,
  logOut,
  fetchUserData,
  setIsAdmin,
  setApiCall,
  setLeaveApiCall,
  setEarnedApiCall,
  setSideMenu,
  setPermanentDeleteApiCall,
  setRecurringLeaveApiCall,
  setOrgExpiringCall,
  setSelectedSub,
  setSelectedTitle,
  resetSelected,
  setOrgLogo,
  fetchApplicantLoginData,
  setEmployeeAllLeaveData,
  setAuthChecked,
  setAuthenticated,
} = userDetailSlice.actions;
export default userDetailSlice.reducer;
